
import {Subject,Subscription} from 'rxjs';
import { Injectable } from "@angular/core";

@Injectable()
export class EmitterService {
  private eventBus$= new Subject();
  subscribe(next):Subscription{
    return this.eventBus$.subscribe(next);
  }
  next(event){
    this.eventBus$.next(event);
  }
}

